import { useEffect } from 'react';

import { useLocale } from 'state/intl';
import { useGatewayFlags } from 'state/launchdarkly';
import { useMParticleContext } from 'state/mParticle';

import { Header, setHeaders } from '../headers';

/**
 * Synchronizes dynamic context values with http headers to be sent with each GraphQL request
 */
export const useHeadersSync = () => {
  const { language, region } = useLocale();
  const { sessionId } = useMParticleContext();
  const gatewayFlags = useGatewayFlags();

  useEffect(() => {
    setHeaders(Header.LANGUAGE, language);
    setHeaders(Header.REGION, region);
    setHeaders(Header.SESSION_ID, sessionId);
    setHeaders(Header.GATEWAY_FLAGS, gatewayFlags);
  }, [language, region, sessionId, gatewayFlags]);
};
